import { render, staticRenderFns } from "./peiyinList.vue?vue&type=template&id=c8619f78&scoped=true"
import script from "./peiyinList.vue?vue&type=script&lang=js"
export * from "./peiyinList.vue?vue&type=script&lang=js"
import style0 from "./peiyinList.vue?vue&type=style&index=0&id=c8619f78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8619f78",
  null
  
)

export default component.exports